module.exports = __webpack_public_path__ + "img/notifications.241584cd.svg";